import React, { useEffect, useState } from "react";
import { useLocalStorage } from "components/hooks";
import { uniqueId } from "lodash";
import BrandDetailsCardSkeleton from "./BrandDetailsCardSkeleton";
import { LOCAL_STORAGE_KEYS } from "../../constants";

type Props = { count: number };

function BrandDetailsCardSkeletonMultiple({ count }: Props) {
  const [skeletons, setSkeletons] = useState<JSX.Element[]>([]);
  const [activeLayout] = useLocalStorage<0 | 1>(LOCAL_STORAGE_KEYS.DISCOVER_PAGE_LAYOUT, 0);

  useEffect(() => {
    const newSkeletons: JSX.Element[] = [];
    for (let i = 0; i < count; i += 1) {
      newSkeletons.push(<BrandDetailsCardSkeleton key={uniqueId("skeletons_")} layout={activeLayout} />);
    }
    setSkeletons(newSkeletons);
  }, [count, activeLayout]);

  // eslint-disable-next-line react/jsx-no-useless-fragment
  return <>{skeletons}</>;
}

export default React.memo(BrandDetailsCardSkeletonMultiple);
